import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface } from '@src/components/pl-base-widget'

import { BundlePurchaseV2WidgetComponent } from './bundle-purchase-v2-widget.component'

import type { BundlePurchaseV2WidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

/**
 * BUNDLE_PURCHASE_V2 widget — the SVD bundle buy box, emitted instead of BUNDLE_PURCHASE on an
 * `enrichVersion=V2` bundle session. Adapts the V2 payload to the `Bundle` domain (every constituent through
 * the same `productPurchaseV2ToSvdWire` → `svdToProduct` chain the single-product V2 buy box uses) and
 * renders the shared `BundleProductPurchase` organism on its SVD branch.
 */
export const BundlePurchaseV2Widget: PLTypedWidgetInterface<BundlePurchaseV2WidgetData, WidgetType.BUNDLE_PURCHASE_V2> =
  {
    id: WidgetType.BUNDLE_PURCHASE_V2,
    errorBoundary: PLBaseErrorBoundary,
    render: BundlePurchaseV2WidgetComponent,
  }
